import { } from 'vue';
import BaseSetupService from '@/setup/BaseSetupService';
import useMembershipService from '@/services/MembershipService';

type Props = SetupProps<typeof DashboardTempWorkerAddMembershipMarketingCardSetupService.props>

export default class DashboardTempWorkerAddMembershipMarketingCardSetupService extends BaseSetupService<Props> {
	static readonly props = undefined;

	get relatedAgencies () { return useMembershipService().relatedAgencies; }

	constructor (props?: Props) {
		super(props);
	}

	openTempWorkerAddMembershipModal () {
		useMembershipService().openTempWorkerAddMembershipModalAsync();
	}
}
